import { HoldingClass, Transaction } from 'types';

export const getHoldingClassFromTransaction = (
  transaction: Transaction
): HoldingClass | null => {
  const { shareClass } = transaction;
  return typeof shareClass !== 'string' && shareClass != null
    ? (shareClass as HoldingClass)
    : null;
};
